import React, { useRef } from "react";

import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import iconMarker from "leaflet/dist/images/marker-icon.png";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
import { useState } from "react";
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: iconMarker,
  shadowUrl: iconShadow,
});

const AddMarker = ({data,selected}) => {
  const data1=data?.map(item=>{
    const {longitude,latitude}=item
    return [longitude,latitude]
  })
 
  return (
<>

<MapContainer className="MappCon"  center={data1[0]} zoom={5}>
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      
    />
    
    {data1?.map((item,index)=>{
        return <div >
            <Marker   key={index} position={item}>
        {/* <Popup openOnMount='true'> <span style={{cursor:'pointer'}}>{data[index]?.name}</span> 
        </Popup> */}
      </Marker>
        </div>
    })}
    
  </MapContainer>
  
</>
  );
};
export default AddMarker